export const NAME = 'wrappingTypes';